var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisputeSettled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48112",
    "data-name": "Group 48112",
    transform: "translate(-1796 -336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_94253",
    "data-name": "Path 94253",
    transform: "translate(1796 336)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25 2 C 21.89414024353027 2 18.88224029541016 2.607841491699219 16.04798126220703 3.806629180908203 C 13.30939102172852 4.964958190917969 10.84946823120117 6.623619079589844 8.736541748046875 8.736541748046875 C 6.623619079589844 10.84946823120117 4.964958190917969 13.30939102172852 3.806629180908203 16.04798126220703 C 2.607841491699219 18.88224029541016 2 21.89414024353027 2 25 C 2 28.10585975646973 2.607841491699219 31.11775970458984 3.806629180908203 33.95201873779297 C 4.964958190917969 36.69060897827148 6.623619079589844 39.15052795410156 8.736541748046875 41.26345825195312 C 10.84946823120117 43.37638092041016 13.30939102172852 45.03504180908203 16.04798126220703 46.1933708190918 C 18.88224029541016 47.39215850830078 21.89414024353027 48 25 48 C 28.10585975646973 48 31.11775970458984 47.39215850830078 33.95201873779297 46.1933708190918 C 36.69060897827148 45.03504180908203 39.15052795410156 43.37638092041016 41.26345825195312 41.26345825195312 C 43.37638092041016 39.15052795410156 45.03504180908203 36.69060897827148 46.1933708190918 33.95201873779297 C 47.39215850830078 31.11775970458984 48 28.10585975646973 48 25 C 48 21.89414024353027 47.39215850830078 18.88224029541016 46.1933708190918 16.04798126220703 C 45.03504180908203 13.30939102172852 43.37638092041016 10.84946823120117 41.26345825195312 8.736541748046875 C 39.15052795410156 6.623619079589844 36.69060897827148 4.964958190917969 33.95201873779297 3.806629180908203 C 31.11775970458984 2.607841491699219 28.10585975646973 2 25 2 M 25 0 C 38.80712127685547 0 50 11.19287872314453 50 25 C 50 38.80712127685547 38.80712127685547 50 25 50 C 11.19287872314453 50 0 38.80712127685547 0 25 C 0 11.19287872314453 11.19287872314453 0 25 0 Z",
    stroke: "none",
    fill: "#a1a3ef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-shield",
    "data-name": "Icon feather-shield",
    d: "M15.223,26.057s9.223-4.611,9.223-11.528V6.458L15.223,3,6,6.458v8.07C6,21.445,15.223,26.057,15.223,26.057Z",
    transform: "translate(1806.277 346.472)",
    fill: "none",
    stroke: "#a1a3ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M3.136,11.327l-3-3a.462.462,0,0,1,0-.653l.653-.653a.462.462,0,0,1,.653,0L3.462,9.042l4.33-4.33a.462.462,0,0,1,.653,0l.653.653a.462.462,0,0,1,0,.653L3.789,11.327A.462.462,0,0,1,3.136,11.327Z",
    transform: "translate(1816.884 352.98)",
    fill: "#a1a3ef",
    stroke: "#a1a3ef",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputeSettled);
export default __webpack_public_path__ + "static/media/DisputeSettled.696b5fe0370572894fcccf7b6a026b6c.svg";
export { ForwardRef as ReactComponent };